import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class GeomagneticService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'gw';

  forecast(): Observable<GeomagneticForecastItem[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<GeomagneticForecastItem[]>(uri, {headers: headers});
  }
  current(): Observable<GeomagneticCurrentItem> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/current';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<GeomagneticCurrentItem>(uri, {headers: headers});
  }
  archive(): Observable<GeomagneticArchiveItem[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/archive';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<GeomagneticArchiveItem[]>(uri, {headers: headers});
  }
  solarActivity(date?): Observable<SolarActivityItem[]> {
    const year = `y=${date.year ? date.year : ''}`;
    const month = `m=${date.month ? date.month : ''}`;
    const day = `d=${date.day ? date.day : ''}`;
    const params = `?${year}&${month}&${day}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/solar' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<SolarActivityItem[]>(uri, {headers: headers});
  }
}

interface GeomagneticForecastItem {
  SD: string,
  ST: string,
  F00_03: string,
  F03_06: string,
  F06_09: string,
  F09_12: string,
  F12_15: string,
  F15_18: string,
  F18_21: string,
  F21_00: string,
}
interface GeomagneticCurrentItem {
  D: string,
  K: string,
  N: string,
  G: string
}
interface GeomagneticArchiveItem {
  date: string,
  data: {
    K00: number,
    K03: number,
    K06: number,
    K09: number,
    K12: number,
    K15: number,
    K18: number,
    K21: number,
  }
}
interface SolarActivityItem {
  Date: string,
  Times: string,
  Density: number,
  Vsw: number,
  PM_Min: number,
  PM_Max: number
}